import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from '../../shared/topBar/TopBar';
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { getTaxEntityDetailAction, getTaxEntityListAction } from "../../actions/investorAccounts";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { Tab, Tabs } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

export const InvestorAccountsDetails = () => {
    const param = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();

    const Gstate = useSelector(state => state);
    const taxEntityList = Gstate.investorAccounts.taxEntityList || [];
    const taxEntityDetails = Gstate.investorAccounts.taxEntityDetail || {};
    const istaxEntityDetailsLoading = Gstate.investorAccounts.isTaxEntityDetailLoading;

    const [taxEntity, setTaxEntity] = useState(taxEntityDetails);

    const [detailedTaxEntity, setDetailedTaxEntity] = useState(taxEntityDetails);

    const Level = [{ BreadCrumb: "Investor >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Accounts >`, Routes: `${UrlPath.InvestorAccounts}` }, { BreadCrumb: `${detailedTaxEntity?.TaxEntityName}`, Routes: `${UrlPath.InvestorAccountDetails}${param.EntityID}` }];

    useEffect(() => {
        setTaxEntity(taxEntityDetails);
        setDetailedTaxEntity(taxEntityDetails);
    }, [taxEntityDetails]);

    useEffect(() => {
        document.title = "Account Details"
        dispatch(getTaxEntityListAction());
        if (param.EntityID)
            dispatch(getTaxEntityDetailAction(param.EntityID));
    }, []);


    const updateTaxEntity = (e) => {
        const newValue = e?.value
        if (newValue) {
            setTaxEntity(newValue);
        }
    };
    const getSelectedTaxEntity=()=>{
        if (taxEntity?.TaxEntityId) {
            dispatch(getTaxEntityDetailAction(taxEntity.TaxEntityId));
            history(`${UrlPath.InvestorAccountDetails}${taxEntity.TaxEntityId}`);
        }
    }

    return (
        <>
            <TopBar label={"Account Details"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white p-3 border rounded">
                        <div className="row my-2">
                            <div className="col-sm-12 col-md-4  my-1">
                                <label for="Account" className="mb-1"> Select Account</label>
                                <SBAComboBox data={taxEntityList} textField={"TaxEntityName"} valueField={"TaxEntityId"} value={taxEntity} onChange={updateTaxEntity} />
                            </div>
                            <div className="col-sm-12 col-md-2 my-1 row-items">
                                <button className="p-sm-btn mx-1" onClick={()=>{getSelectedTaxEntity()}}> Enter</button>
                            </div>
                        </div> {istaxEntityDetailsLoading ? <><LoadingScreen /></> :
                            <><AccountDetails details={detailedTaxEntity} entityID={param.EntityID} /></>}
                    </div>
                </div>
            </div>
        </>
    )
};
export const AccountDetails = ({ details, entityID }) => {
    const history = useNavigate();
    const param = useParams();
    const location = useLocation();
    const preActiveTab = location?.state?.ActiveTab || "General";

    const [accountDetail, setAccountDetail] = useState(details);
    const [activeTab, setActiveTab] = useState(preActiveTab);
    useEffect(() => {
        setAccountDetail(details);
    }, [details]);
    return <>
        <div >
            <Tabs
                defaultActiveKey={'General'}
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
                id="uncontrolled-tab-example"
                className="ps-3 border-0"
            >
                <Tab eventKey="General" title="General">
                    {activeTab === 'General' && <><GeneralInfo details={accountDetail} entityID={entityID} /></>}
                </Tab>
                <Tab eventKey="Register Address" title="Addresses">
                    {activeTab === 'Register Address' && <><Addresses details={accountDetail} entityID={entityID} /></>}
                </Tab>
            </Tabs>
        </div>
    </>
};
export const GeneralInfo = ({ details, entityID }) => {
    const [detail, setDetail] = useState(details);
    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;
    const history = useNavigate();
    useEffect(() => {
        setDetail(details);
    }, [details]);
    const navigateToEdit = () => {
        history(`${UrlPath.InvestorAccountEdit}${entityID}`, { state: { ActiveTab: "General" } })
    }
    return <>
        <div className="bg-white life-science  p-3">
            <div className="d-flex flex-row-reverse py-2">
                <i className={isEditable ? "fas fa-pencil edit_icon text-primary" : "fas fa-pencil edit_icon"} onClick={() => { isEditable && navigateToEdit()}}></i>
            </div>
            <div className="row m-0 p-0 border-bottom ">
                <div className="col-md-8">
                    <div className="border-bottom my-2">
                        <p class="fw-medium"> Account Information </p>
                        <div className="row m-0 my-2">
                            <Labelvalue label={"Entity Name"} value={detail?.TaxEntityName} colSize={"col-md-4"} />
                            <Labelvalue label={"Abbreviation"} value={detail?.Abbreviation} colSize={"col-md-4"} />
                            <Labelvalue label={"Status"} value={detail?.TaxEntityStatusName} colSize={"col-md-4"} />                           
                        </div>
                        <div className="row m-0 my-2">
                            <Labelvalue label={"Relationship Master"} value={detail?.ContactName} colSize={"col-md-4"} />
                            <Labelvalue label={"TaxID"} value={detail?.TaxId} colSize={"col-md-4"} copyIcon={true} eyeIcon />
                            <Labelvalue label={"Inception Date"} value={detail?.InceptionDate ? moment(detail?.InceptionDate).format('MM-DD-YYYY')  : ""} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                        <Labelvalue label={"Linked Portfolio"} value={detail?.PortfolioName} colSize={"col-md-4"} />
                        </div>
                    </div>
                    <div className="my-2">
                        <p class="fw-medium"> Legal Information </p>
                        <div className="row m-0 my-2">
                            <Labelvalue label={"Currency"} value={detail?.CurrencyName} colSize={"col-md-4"} />
                            <Labelvalue label={"Form PF"} value={detail?.FormPF} colSize={"col-md-4"} />
                            <Labelvalue label={"Tax Status"} value={detail?.TaxStatusName} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                            <Labelvalue label={"Finra 5130"} value={detail?.Finra5130Name} colSize={"col-md-4"} />
                            <Labelvalue label={"Finra 5131"} value={detail?.Finra5131Name} colSize={"col-md-4"} />
                            <Labelvalue label={"New Issue"} value={detail?.NewIssueName} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                            <Labelvalue label={"Erisa"} value={detail?.Erisa} colSize={"col-md-4"} />
                            <Labelvalue label={"Erisa Percentage (%)"} value={detail?.ErisaPercent} colSize={"col-md-4"} />
                            <CheckBoxValue label={"Restricted"} value={detail?.IsRestricted} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                            <CheckBoxValue label={"Side Letter"} value={detail?.IsSideLetter} colSize={"col-md-4"} />
                            <CheckBoxValue label={"CTFC"} value={detail?.CFTC} colSize={"col-md-4"} />
                            <CheckBoxValue label={"Side Pocket"} value={detail?.IsSidePocket} colSize={"col-md-4"} />
                        </div>
                    </div>
                </div>
                <DetailedViewer colSize={"col-md-4 "} value={detail?.Notes} label={"Account Notes"}></DetailedViewer>
            </div>


            <div className="border-bottom my-1">
                <p class="fw-medium"> Wire Information </p>
                <div className="row m-0 my-2">
                    <div className="col-md-8 p-0">
                        <div className="row m-0 my-2  ">
                            <Labelvalue copyIcon label={"Wire Instruction Name"} value={detail?.WireInstitutionName} colSize={"col-md-4"} />
                            <Labelvalue copyIcon label={"Bank Name"} value={detail?.BankName} colSize={"col-md-4"} />
                            <Labelvalue copyIcon label={"Wire Bank Information"} value={detail?.WireBankInformation} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                            <Labelvalue copyIcon label={"Wire ABA"} value={detail?.WireABANumber} colSize={"col-md-4"} />
                            <Labelvalue copyIcon label={"Wire Account Number"} value={detail?.WireAccountNumber} colSize={"col-md-4"} />
                            <Labelvalue copyIcon label={"Wire Additional Instructions"} value={detail?.WireAdditionalInstructions} colSize={"col-md-4"} />
                        </div>
                        <div className="row m-0 my-2">
                            <Labelvalue  label={"Stock Delivery Instructions"} value={detail?.StockDeliveryInstructions} colSize={"col-md-4"} />
                        </div>
                    </div>
                    <DetailedViewer colSize={"col-md-4"} value={detail?.WireNotes} label={"Wire Notes"} ></DetailedViewer>
                </div>
            </div>
            <div className="border-bottom my-2">
                <p class="fw-medium"> </p>
                <div className="row m-0 my-2">
                    <Labelvalue label={"Created By"} value={detail?.CreatedByName} colSize={"col-md-3"} />
                    <Labelvalue label={"Created Date"} value={moment(detail?.CreatedDate).format('MM-DD-YYYY')} colSize={"col-md-3"} />
                    <Labelvalue label={"Modified By"} value={detail?.ModifiedByName} colSize={"col-md-3"} />
                    <Labelvalue label={"Modified Date "} value={moment(detail?.ModifiedDate).format('MM-DD-YYYY')} colSize={"col-md-3"} />
                </div>
            </div>
        </div>
        <ToastContainer/>
    </>
};
export const Addresses = ({ details, entityID }) => {
    const [detail, setDetail] = useState(details);
    const history = useNavigate();
    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;

    useEffect(() => {
        setDetail(details);
    }, [details]);
    const navigateToEdit = () => {
        history(`${UrlPath.InvestorAccountEdit}${entityID}`, { state: { ActiveTab: "Register Address" } })
    }
    return <>
        <div className="detail p-2">
            <div className="d-flex flex-row-reverse py-2">
                <i className={isEditable ? "fas fa-pencil edit_icon text-primary" : "fas fa-pencil edit_icon"} onClick={() => { isEditable && navigateToEdit()}}></i>
            </div>
            <div className="border-bottom my-2">
                <p class="fw-medium"> Register Address</p>
                <div className="row m-0 my-2">
                    <Labelvalue copyIcon label={"Address"} value={detail?.RegisteredAddress} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"City"} value={detail?.RegisteredCity} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"State"} value={detail?.RegisteredState} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"Zip"} value={detail?.RegisteredZip} colSize={"col-md-3"} />
                </div>
             
                <div className="row m-0 my-2">
                    <Labelvalue copyIcon label={"Province"} value={detail?.RegisteredProvince} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"Country"} value={detail?.RegisteredCountry} colSize={"col-md-3"} />
                </div>
            </div>
            <div className="my-2">
                <p class="fw-medium"> Statement Address</p>
                <div className="row m-0 my-2">
                    <Labelvalue copyIcon label={"Address"} value={detail?.RegisteredAddress} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"City"} value={detail?.RegisteredCity} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"State"} value={detail?.RegisteredState} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"Zip"} value={detail?.RegisteredZip} colSize={"col-md-3"} />
                </div>
                <div className="row m-0 my-2">
                    <Labelvalue copyIcon label={"Province"} value={detail?.RegisteredProvince} colSize={"col-md-3"} />
                    <Labelvalue copyIcon label={"Country"} value={detail?.RegisteredCountry} colSize={"col-md-3"} />
                </div>
            </div>
        </div>
    </>
};
export const Others = ({ details }) => {
    return <>
        <div className="detail p-2">
            Others
        </div>
    </>
};
export const Labelvalue = ({ label, value, colSize, copyIcon, eyeIcon }) => {
    const [hide, setHide] = useState(eyeIcon);
    return <div className={colSize}>
        <span class="fw-medium" style={{fontSize:'12px'}}>{label} {copyIcon && <i class="fa-regular fa-copy" onClick={() => { navigator.clipboard.writeText(value) }}></i>}</span>
        {eyeIcon ? <> {hide ?
            <>
                <p class="fw-medium"> {'*'.repeat(value?.length || 1)} <i class="fa-regular fa-eye-slash" onClick={() => { setHide(false) }}></i> </p>
            </>
            : <> <p class="fw-medium"> {value || '-'}  <i class="fa-regular fa-eye" onClick={() => { setHide(true) }}></i></p>
            </>} </> :
            <p class="fw-medium"> {value || '-'}  </p>}
    </div>
};
export const CheckBoxValue = ({ label, value, colSize }) => {
    return <div className={colSize}>
        <input type="checkbox" checked={value} className="me-2"/>
        <span >{label} </span>
    </div>
};
export const DetailedViewer = ({ label, value, colSize }) => {
    return <div class={colSize} >
        <span class="fw-medium">{label}</span>
        <div className="py-2 life-science rounded" style={{ backgroundColor: "#eaf6ff" ,minHeight:'75%' ,maxHeight:'400px',overflowX:'auto'  }}>
            <div class="accordion accordion-flush" >
                <div >
                    <div class="accordion-collapse collapse show">
                        <div class="accordion-body" style={{ overflowX: "auto" }}>
                            <p>{value}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}